import CustomSelectWithInfiniteScroll from 'common/components/CustomSelectWithInfiniteScroll';
import CalendarType from 'common/enums/calendarTypes';
import { useSelector } from 'react-redux';
import { getAllFilters } from 'redux/slices/icalendarFilterSlice';
import { fetchCalendarsAction } from 'redux/slices/iCalendarV4';

const SelectAssets = (props) => {
    // If this component is used in the calendar filter context, use Redux state
    const filters = useSelector(getAllFilters);
    // Use props.id if provided (for other contexts) or get it from Redux state
    const assetId = props.id || filters.asset || 'all';

    return (
        <CustomSelectWithInfiniteScroll
            {...props}
            id={assetId}
            idProperty="canonicalId"
            type="asset"
            queryParams={{
                type: CalendarType.ASSET,
            }}
            selectAll={true}
            fetchAction={fetchCalendarsAction}
            label={(item) => (
                <>
                    {item.name} ( {item?.extraFields?.resourceId} )
                </>
            )}
            i18nKeys={{
                searchPlaceholder: 'iCalendar.filter.searchAssets',
                allItems: 'iCalendar.filter.allAssets',
            }}
        />
    );
};

export default SelectAssets;
